import React from "react";
import UserChart from "./UserChart";
import FeedChart from "./FeedChart";
import ReportedUsers from "./ReportedUsers";

const DataAnalysis = () => {
  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#1a1a1a",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>
      <h1 style={{
        color: "white",
        fontSize: "clamp(1.25rem, 4vw, 2rem)",
        fontWeight: 700,
        marginBottom: "24px",
      }}>
        Data Analysis
      </h1>
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        width: "100%",
      }}>
        <UserChart />
        <FeedChart />
        <ReportedUsers />
      </div>
    </div>
  );
};

export default DataAnalysis;